import styled, { css } from 'styled-components';

import { StyledMenuBlock } from '../../Blocks/MenuBlock/MenuBlock.styled';

/* ------------------------------ ShadowHeader ------------------------------ */

export const ShadowHeader = styled.div``;

/* ------------------------------- LogoWrapper ------------------------------ */

export const LogoWrapper = styled.div`
    margin-right: auto;

    > a {
        display: block;
    }

    img {
        transition: width 0.3s ease, height 0.3s ease;
        will-change: width, height;
        max-width: 100%;
        object-fit: contain;
        object-position: left center;
    }
`;

/* ------------------------------ CtaMenuBlock ------------------------------ */

export const CtaMenuBlock = styled.div`
    display: none;
    align-items: center;
    gap: 1rem;

    @media screen and (min-width: 768px) {
        display: flex;
    }
`;

/* --------------------------- StickyCtaMenuBlock --------------------------- */

export const StickyCtaMenuBlock = styled(CtaMenuBlock)`
    position: fixed;
    display: flex;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 10;
    background-color: ${({ theme }) => theme.sections.header.background};
    padding: 1rem 1.5rem;
    justify-content: center;
    box-shadow: 0px -6px 6px 0px rgba(0, 0, 0, 0.6);

    @media screen and (min-width: 768px) {
        display: none;
    }
`;

export const ShadowSticky = styled(StickyCtaMenuBlock)`
    position: static;
    z-index: 0;
    visibility: hidden;
    margin-top: 1rem;
`;

/* --------------------------- StyledHeaderSection -------------------------- */

export const StyledHeaderSection = styled.header<{
    scrolled: boolean;
    searchOpen: boolean;
}>(
    ({ scrolled, theme, searchOpen }) => css`
        align-items: center;
        background-color: ${theme.sections.header.background};
        color: ${theme.sections.header.featureText};
        display: grid;
        row-gap: 1rem;
        padding: 1rem 1.5rem 0;
        font-size: 0.875rem;

        position: sticky;
        top: 0;
        width: 100%;
        z-index: 900;

        grid-template-columns: ${searchOpen
            ? '0   1fr min-content'
            : '1fr   min-content min-content'};

        ${LogoWrapper} img {
            height: ${scrolled ? '30px' : '40px'};
            width: ${scrolled ? '150px' : '200px'};
        }

        ${StyledMenuBlock} {
            grid-row: 2;
            grid-column: 1 / 4;
        }

        @media screen and (min-width: 768px) {
            grid-template-columns: ${searchOpen
                ? '1fr min-content minmax(auto, 350px) min-content'
                : '1fr min-content min-content min-content'};
        }

        @media screen and (min-width: 1080px) {
            padding: 1rem 2rem;

            grid-template-columns: ${searchOpen
                ? 'auto 1fr  min-content minmax(auto, 350px) min-content'
                : 'auto 1fr  min-content min-content min-content'};

            ${StyledMenuBlock} {
                grid-row: 1;
                grid-column: 2;
            }
        }

        @media screen and (min-width: 85rem) {
            padding: 1rem 6rem;
        }
    `,
);
